export default "__VITE_ASSET__a2af0c8a__"